import React, {createContext, useEffect, useState, useCallback} from 'react';
import { authAPI } from "../api/authApi";
import { jwtDecode } from 'jwt-decode';
import { isAdminDashboardToken } from '../utils/authToken.js';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({ _id: '', name: '', email: '' });
    const storedUserId = localStorage.getItem("userId");

    const refreshUser = useCallback(async () => {
        const token = localStorage.getItem('token');

        if (token && isAdminDashboardToken(token)) {
            setUser({ _id: '', name: '', email: '' });
            return;
        }
        
        if (token) {
            try {
                const response = await authAPI.getUserData();
                
                setUser({ _id: response.data.data._id, name: response.data.data.name, email: response.data.data.email });
            } catch (err) {
                // Fallback: Try to decode token and use stored userId
                try {
                    const decoded = jwtDecode(token);
                    
                    const storedUserId = localStorage.getItem('userId');
                    if (decoded && storedUserId) {
                        setUser({ 
                            _id: storedUserId, 
                            name: decoded.name || '', 
                            email: decoded.email || '' 
                        });
                    } else {
                        setUser({ _id: '', name: '', email: '' });
                        if (!isAdminDashboardToken(token)) {
                            localStorage.removeItem('token');
                            localStorage.removeItem('userId');
                        }
                    }
                } catch (decodeErr) {
                    setUser({ _id: '', name: '', email: '' });
                    if (!isAdminDashboardToken(token)) {
                        localStorage.removeItem('token');
                        localStorage.removeItem('userId');
                    }
                }
            }
        } else {
            setUser({ _id: '', name: '', email: '' });
        }
    }, []);

    useEffect(() => {
        refreshUser();
    }, [refreshUser]);

    useEffect(() => {
        const handleAuthCleared = () => {
            setUser({ _id: '', name: '', email: '' });
        };
        const handleFocus = () => {
            if (!localStorage.getItem('token')) {
                setUser({ _id: '', name: '', email: '' });
            }
        };
        window.addEventListener('app:auth-cleared', handleAuthCleared);
        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('app:auth-cleared', handleAuthCleared);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, storedUserId, refreshUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
